import { render, staticRenderFns } from "./editor-Invite-Modal.vue?vue&type=template&id=123ffbe3&scoped=true";
import script from "./editor-Invite-Modal.vue?vue&type=script&lang=js";
export * from "./editor-Invite-Modal.vue?vue&type=script&lang=js";
import style0 from "./editor-Invite-Modal.vue?vue&type=style&index=0&id=123ffbe3&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "123ffbe3", null);
export default component.exports;